import React from 'react';
import './EvidenceTrailPopup.css';

/**
 * Modal popup that displays page-level evidence trail for a given
 * execution trace's context_assembly. Receives evidence_nodes and
 * verbatim_nodes arrays from context_assembly (which include source_pages).
 */
export default function EvidenceTrailPopup({ open, onClose, evidenceNodes, verbatimNodes }) {
  if (!open) return null;

  const allNodes = [
    ...(evidenceNodes || []).map(n => ({ ...n, _kind: 'evidence' })),
    ...(verbatimNodes || []).map(n => ({ ...n, _kind: 'verbatim' })),
  ];

  const rows = [];
  for (const node of allNodes) {
    const sourcePages = node.source_pages || [];
    if (sourcePages.length > 0) {
      for (const sp of sourcePages) {
        rows.push({
          docName: sp.doc_name || node.source_doc_name || 'Unknown',
          pages: (sp.pages || []).join(', '),
          referenceText: sp.reference_text || '',
          nodeLabel: node.label || node.node_id || '',
          kind: node._kind,
        });
      }
    } else if (node.source_doc_name) {
      rows.push({
        docName: node.source_doc_name,
        pages: '',
        referenceText: node.description || node.nl_text || '',
        nodeLabel: node.label || node.node_id || '',
        kind: node._kind,
      });
    }
  }

  return (
    <div className="et-overlay" onClick={onClose}>
      <div className="et-popup" onClick={e => e.stopPropagation()}>
        <div className="et-header">
          <h3 className="et-title">Evidence Trail</h3>
          <button className="et-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>

        <div className="et-body">
          {rows.length === 0 ? (
            <p className="et-empty">No page-level evidence data available for this response.</p>
          ) : (
            <table className="et-table">
              <thead>
                <tr>
                  <th>Source Document</th>
                  <th>Page(s)</th>
                  <th>Reference Text</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={idx} className={row.kind === 'verbatim' ? 'et-row-verbatim' : ''}>
                    <td className="et-cell-doc">{row.docName}</td>
                    <td className="et-cell-page">{row.pages || '—'}</td>
                    <td className="et-cell-ref">
                      {row.referenceText
                        ? (row.referenceText.length > 200
                          ? row.referenceText.substring(0, 200) + '...'
                          : row.referenceText)
                        : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
